import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BranchesDialogService} from "../../services/branches-dialogs-service.service";
import {BranchesService} from "../../services/branches-service.service";
import {BranchModel} from "../../models/branch.model";
import {WorkloadService} from "../../../workload/services/workload-service.service";
import {workLoadModel} from "../../../workload/models/work-load.model";
import {WorkloadAlerts} from "../../../workload/services/workload-alerts.service";
import {error} from "jquery";

export class branchesInfoViewCtrl implements IController {

  branch: BranchModel;
  programTypes: any;

  private selectedPrograms: any;
  private workload: workLoadModel;
  public workloadCopy: workLoadModel;
  public isSaveAvailable: boolean;
  public branchCopy: BranchModel;

  /* @ngInject */
  constructor(private branchesService: BranchesService, private $log, private branchesDialogService: BranchesDialogService,
              private workloadService: WorkloadService, private workloadAlerts: WorkloadAlerts) {
  }

  $onInit() {
    if (!_.get(this.branch, 'branchConfiguration')) {
      this.branch.branchConfiguration = {
        considerAccounts: undefined,
        considerDepots: undefined,
        considerAreas: undefined,
        programTypes: undefined
      }
    }
    this.selectedPrograms = this._getSelectedPrograms(this.branch.branchConfiguration.programTypes);

    // this.workloadService.getWorkLoad(this.branch.id, 'Branch')
    //   .then((workload: workLoadModel) => {
    //     this.workload = workload;
    //     this.workloadCopy = angular.copy(this.workload);
    //   })

    this.branchCopy = angular.copy(this.branch);

  }

  updateAutoAssign() {
    this._onUpdateBranch(this.branch.id, this.branch);
  }

  onAddBranchPrograms($event) {
    this.branchesDialogService.addBranchPrograms($event, this.programTypes, this.branch.branchConfiguration)
      .then((branchConfigurationToUpdate) => {
        this._addBranchPrograms(branchConfigurationToUpdate);
      })
      .catch((error) => {
        this.$log.error('Failed to add programs @branchesInfoView@onAddBranchPrograms', error)
      })
      .finally(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onRemoveBranchProgram(program) {
    const programToRemoveIdx = this.branch.branchConfiguration.programTypes.findIndex((p) => {
      return p === program.programKey;
    });
    this.branch.branchConfiguration.programTypes.splice(programToRemoveIdx, 1);
    this._onUpdateBranch(this.branch.id, this.branch);
  }

  onChangeContacts(contacts) {
    this.branch.contactPeople = angular.copy(contacts);
    this.onUpdate();
  }

  onUpdate() {
    this.isSaveAvailable = !_.isEqual(this.branch, this.branchCopy);
  }

  onCancelChanges() {
    this.branch = angular.copy(this.branchCopy);
    this.onUpdate();
  }

  onSave(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this._onUpdateBranch(this.branch.id, this.branch);
      }
    }
  }


  _getSelectedPrograms(programTypesIds) {
    return _.map(programTypesIds, (pId) => {
      const programRef = _.find(this.programTypes, (program) => {
        return program.id === pId;
      });
      return {programKey: pId, programName: _.get(programRef, 'name')};
    });
  }

  _addBranchPrograms(branchConfigurationToUpdate) {
    const branchCopy = angular.copy(this.branch);
    branchCopy.branchConfiguration = branchConfigurationToUpdate;

    this._onUpdateBranch(this.branch.id, branchCopy);
  }

  _onUpdateBranch(branchId, branch: BranchModel) {
    this.branchesService.updateBranch(branchId, branch)
      .then((updatedBranch: any) => {
        this.branch = updatedBranch;
        this.branchCopy = angular.copy(updatedBranch);
        this.isSaveAvailable = false;
        this.$onInit();
      })
      .catch((error) => {
        this.$log.error(error);
      })
  }
}

angular
  .module('bringoz.admin.branches')
  .component('branchesInfoView', {
    bindings: {
      branch: '<',
      programTypes: '<'
    },
    template: require('./branches-info-view.html').default,
    controller: branchesInfoViewCtrl
  });
